import { fadeInAnimation } from '@/app/styles';
import styled, { css } from 'styled-components';
import { Attribute, SectionTitle, Value } from './details-info-mod-styles';

const Wrapper = styled.div`
  ${fadeInAnimation()}

  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  page-break-inside: avoid;
`;

const flexCSS = css`
  display: flex;
  justify-content: space-between;
`;

const ColumnWrapper = styled.div`
  ${flexCSS}
  gap: 20px;
`;

const Row = styled.div`
  ${flexCSS}
  margin-top: 10px;
`;

const Column = styled.div`
  width: 100%;

  :first-child {
    @media print {
      margin-right: 20px;
    }
  }
`;

const IconWrapper = styled.span`
  margin: auto;
  padding-left: 6px;
`;

const mappedValues = {
  true: 'Yes',
  false: 'No',
};

function InfoItem({ attribute, icon, value, isValueUnderlined }) {
  return (
    <Row key={attribute}>
      <Attribute>
        <p aria-label={attribute}>{attribute}</p>
        <IconWrapper>{icon}</IconWrapper>
      </Attribute>
      <Value underlined={isValueUnderlined}>
        {mappedValues[value] || value}
      </Value>
    </Row>
  );
}

function ColumnOfInfoItems({ infoList, dataCy }) {
  return (
    <Column data-cy={dataCy}>
      {infoList.map(([attribute, value, icon, isValueUnderlined]) => {
        if (!value) return null;

        return (
          <InfoItem
            key={attribute}
            attribute={attribute}
            value={value}
            icon={icon}
            isValueUnderlined={isValueUnderlined}
          />
        );
      })}
    </Column>
  );
}

export function DetailsInfoDisplay(props) {
  return (
    <Wrapper>
      {props.CustomTitle || <SectionTitle>{props.title}</SectionTitle>}
      <ColumnWrapper data-cy="license-header-summary-container">
        <ColumnOfInfoItems
          infoList={props.left}
          dataCy="license-header-summary-left-column"
        />
        <ColumnOfInfoItems
          infoList={props.right}
          dataCy="license-header-summary-right-column"
        />
      </ColumnWrapper>
    </Wrapper>
  );
}
